
export enum AccelerometerInfoType {
    Acceleration,
    Deceleration, // Braking
    Cornering
}
